module.exports = __webpack_public_path__ + "static/media/25487329_1703509446390906_3002634440714719473_o.e124893f.jpg";